exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kv-select-options {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n", ""]);

// exports
